module.exports = {
  noCharges: 'No delivery charges',
  from: 'From',
  to: 'to',
  miles: 'miles',
  km: 'Km',
  chargesPerMile: 'Charges per mile',
  chargesByMiles: 'Charges by miles',
  chargesPerKm: 'Charges per kilometer',
  chargesByKms: 'Charges by kilometers',
  chargesByInvoice: 'Charges by invoice amount',
  defaultCharges: 'Default charges',
};



// WEBPACK FOOTER //
// ./src/lang/en/state.js